import {Routes} from "@angular/router";
import {PrivatePage} from "./private.page";
import {Finance} from "./finance/finance";
import {Charge} from "./charge/charge";
import {Payments} from "./payments/payments";

export const privateRoutes: Routes = [
    {
        path: 'main',
        component: PrivatePage,
        children: [

            // {
            //     path: 'dashboard',
            //     component: Dashboard,
            //
            // },

            {
                path: 'finance',
                component: Finance

            },
            {
                path: 'charge',
                component: Charge

            },
            {
                path: 'payments',
                component: Payments

            },
            {
                path: 'sessions',
                loadChildren: () => import('./charging-sessions/charging-sessions.module').then(m => m.ChargingSessionsModule)
            },
            {
                path: 'profile',
                loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
            },

            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.SearchPageModule)
            },
            {
                path: '',
                redirectTo: 'private/tabs/home',
                pathMatch: 'full'
            }
        ]
    }

];
